import axios, { AxiosResponse } from 'axios';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

export interface IDateLimit {
    od: string;
    do: string;
    ucetniden: string;
}

export const useDateLimit = (): [IDateLimit | undefined, boolean, (current: dayjs.Dayjs) => boolean] => {
    const [dateLimits, setDateLimits] = useState<IDateLimit>();
    const [dateLoading, setDateLoading] = useState<boolean>(false);
    const datelimitOffset = 29;
    const commonDisabledDate = (current: dayjs.Dayjs) =>
        dateLimits
            ? current > dayjs(dateLimits.do) ||
              current < dayjs(dateLimits.od) ||
              current > dayjs().add(datelimitOffset, 'days')
            : false;

    useEffect(() => {
        setDateLoading(true);
        axios({
            method: 'GET',
            url: 'Sluzby/Interval'
        })
            .then((resp: AxiosResponse<IDateLimit>) => setDateLimits(resp.data))
            .finally(() => setDateLoading(false));
    }, []);

    return [dateLimits, dateLoading, commonDisabledDate];
};
